module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "breadcrumb"
  }, [_c('ul', [_vm._l((_vm.links), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": link.url
      }
    }, [_vm._v(_vm._s(link.name))])], 1)
  }), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.protocol.title))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49a8e845!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 156
// module chunks = 2